const BRIDGE_URL = 'http://127.0.0.1:9123';
const DEEP_LINK = 'pocprintbridge://wake';
const WAKE_WAIT_MS = 3000;

function escposToBase64(str) {
    const bytes = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i) & 0xff;
    }
    let binary = '';
    bytes.forEach(b => binary += String.fromCharCode(b));
    return btoa(binary);
}

function buildStringDataPrinter(printer) {
    const printerType = detectPrinterType(printer);
    // Para NET usar la IP (path), para otros tipos dejar vacío
    const ethernet = printerType === 'NET' ? (printer.path || '').trim() : '';
    return JSON.stringify({
        opt: 'sendToPrintProtocolComandera',
        printModel: printer.model || printer.name || '',
        ethernet,
        printerType,
        printerOut: 'CUSTOM_WORKSTATION',
        printerPackage: 'null',
        modo: 'printRaw',
        cashdrawer: 'NINGUNO',
        fontType: 'FONT_B',
    });
}

function detectPrinterType(printer) {
    const name = (printer.name || '').toUpperCase();
    const path = printer.path || '';
    if (name.includes('(NET)') || /^\d{1,3}(\.\d{1,3}){3}$/.test(path)) return 'NET';
    if (name.includes('(BT)') || /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/.test(path)) return 'BT';
    return 'USB';
}

function wakeBridge() {
    try {
        // Usar iframe oculto para no navegar fuera de la página actual
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = DEEP_LINK;
        document.body.appendChild(iframe);
        setTimeout(() => iframe.remove(), 2000);
    } catch (e) {
        console.error('No se pudo abrir deep link', e.message);
    }
}

async function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

async function healthCheck() {
    const res = await fetch(`${BRIDGE_URL}/health`, {
        signal: AbortSignal.timeout(2000),
    });
    return res.ok;
}

async function ensureBridgeAlive() {
    try {
        return await healthCheck();
    } catch (err) {
        wakeBridge();
        await wait(WAKE_WAIT_MS);
        try {
            return await healthCheck();
        } catch {
            return false;
        }
    }
}

async function checkPrinterService() {
    const res = await fetch(`${BRIDGE_URL}/check-printer-service`, {
        method: 'POST',
        signal: AbortSignal.timeout(5000),
    });
    const status = await res.text();
    return status === 'installed';
}

async function listPrinters() {
    const res = await fetch(`${BRIDGE_URL}/list-printers`, {
        method: 'POST',
        signal: AbortSignal.timeout(5000),
    });
    const printers = await res.json();
    return printers;
}

async function testConnection(printer) {
    const res = await fetch(`${BRIDGE_URL}/test-connection`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ printer }),
        signal: AbortSignal.timeout(10000),
    });
    const result = await res.text();
    return result;
}

// Códigos de error conocidos del bridge
const BRIDGE_ERROR_CODES = {
    703: 'No se pudo establecer la conexión. Verifique que la impresora esté conectada.',
    708: 'No hay papel en la impresora. Coloque un nuevo rollo e intente nuevamente.',
    709: 'La tapa de la impresora está abierta. Ciérrela e intente nuevamente.',
};

async function printRaw(content, printer) {
    const rawCommandBase64 = escposToBase64(content);
    const stringDataPrinter = buildStringDataPrinter(printer);

    const res = await fetch(`${BRIDGE_URL}/print-raw`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ stringDataPrinter, rawCommandBase64 }),
        signal: AbortSignal.timeout(20000),
    });

    const responseBody = await res.json().catch(() => null);

    // El bridge devuelve HTTP 200 incluso en errores, hay que chequear responseCode
    if (!res.ok || (responseBody && responseBody.responseCode && responseBody.responseCode !== 200)) {
        const code = responseBody?.responseCode || res.status;
        const errorMessage = BRIDGE_ERROR_CODES[code]
            || responseBody?.responseMessage
            || `Error de impresión (${code}). Verifique la conexión con la impresora.`;
        const error = new Error(errorMessage);
        error.printerError = true;
        error.statusCode = code;
        throw error;
    }
    return true;
}

async function printWithRetry(content, printer) {
    try {
        return await printRaw(content, printer);
    } catch (firstErr) {
        // Si el error es de la impresora (no de conexión al bridge), no reintentar
        if (firstErr.printerError) {
            throw firstErr;
        }
        // Error de conexión: despertar bridge y reintentar
        wakeBridge();
        await wait(WAKE_WAIT_MS);
        return await printRaw(content, printer);
    }
}

export {
    ensureBridgeAlive,
    checkPrinterService,
    listPrinters,
    testConnection,
    printWithRetry,
    detectPrinterType,
};
